import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=7358e4c3"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7358e4c3')) {
      api.createRecord('7358e4c3', component.options)
    } else {
      api.reload('7358e4c3', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=7358e4c3", function () {
      api.rerender('7358e4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/Tabs.vue"
export default component.exports